// import React from "react";

const Truncate = ({
    str,
    length = 50
}) => {
    return str.length > length ? str.substring(0, length) + "..." : str;
};

export default Truncate;